import throttle from 'lodash/throttle';

export default class SearchHandler {
  _query;
  request;
  onResult;
  onError;

  _throttleDispatch;

  // latestResult = null;

  _latestFinishedRequestInd = -1;
  _lastRequestInd = -1;
  /**
   * @param {Function} request Async function that dispatches the query and returns the result.
   * @param {Function} onResult Called when the search result is ready.
   * @param {Number} throtleTime
   * @param {Function} onError
   */
  constructor(request, onResult, throtleTime = 500, onError = err => { throw err; }) {
    this.request = request;
    this.onResult = onResult;
    this.onError = onError;
    this._throttleDispatch = throttle(this._dispatchRequest, throtleTime);
  }
  search(newQuery) {
    this._awaitingThrottle = true;
    this._throttleDispatch(newQuery);
  }
  async _dispatchRequest(query) {
    this._awaitingThrottle = false;
    const currReq = this.request(query);
    const currReqInd = ++this._lastRequestInd;
    let res;
    try {
      res = await currReq;
    } catch (err) {
      this.onError(err);
      return;
    }
    if (this._latestFinishedRequestInd > currReqInd) {
      // This request is outdated.
      return;
      // TODO just cancel oudated requests before they're finished instead?
    }
    this._latestFinishedRequestInd = currReqInd;
    // this.latestResult = res;
    this.onResult(res);
    // if (this._latestFinishedRequestInd === this._lastRequestInd && !this._awaitingThrottle) {

    // }
  }
  get awaitingRequest() {
    return this._latestFinishedRequestInd !== this._lastRequestInd;
  }
  get awaitingThrottle() {
    return this._awaitingThrottle;
  }
  get idle() {
    return !this.awaitingRequest && !this.awaitingThrottle;
  }
}
